import React, { useEffect, useState, useMemo } from 'react'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import ImageGallery from 'react-image-gallery'
import "react-image-gallery/styles/css/image-gallery.css"
import PanelHeader from "./PanelHeader"

export default function Sport() {
    const [exists, setExists] = useState(null);
    const [loading, setLoading] = useState(true);
    const panelTitle = "SPoRT Volumetric Soil Moisture"
    const mapurl = 'https://weather.ndc.nasa.gov/sport/dynamic/lis_NEUS//'

    const datePart = useMemo(() => {
      let today = new Date()
      let month = '' + (today.getMonth() + 1)
      let day = '' + today.getDate()
      let year = today.getFullYear()
      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;
      return [year, month, day].join('')
    }, [])

    const sportMaps = useMemo(() => {
      const maptitles = {
            'vsm0-10': '0-10cm',
            'vsm0-40': '0-40cm',
            'vsm0-100': '0-100cm',
            'vsm0-200': '0-200cm',
      }
      let maplist = []
      Object.keys(maptitles).forEach((t) => {
        const mapname = mapurl + t + "percent_" + datePart + "_00z_neus.gif"
        maplist.push({
          original: mapname,
          thumbnail: mapname,
          thumbnailLabel: maptitles[t] || ""
        })
      })
      return maplist
    }, [mapurl, datePart])

    useEffect(() => {
      const checkFile = async () => {
        try {
          const response = await fetch(sportMaps[0].original, { method: 'HEAD' });
          if (response.ok) {
            setExists(true);
          } else {
            setExists(false); 
          }
        } catch (error) {
          console.error("Error verifying file location:", error);
          setExists(false); // Network errors or CORS failures
        } finally {
          setLoading(false);
        }
      };
      checkFile();
    }, [sportMaps])

    return (
      <>
        <PanelHeader
          title={panelTitle}
        />
        {exists &&
          <div className="mapandlegend-container">
            <ImageGallery 
              items={sportMaps} 
              thumbnailPosition="bottom"
              showFullscreenButton={false}
              showPlayButton={false}
              showNav={false}
              slideDuration={200}
              slideInterval={9999}
            />
            <div style={{textAlign:"center", margin:"1em 0"}}>
              <Link href="https://weather.ndc.nasa.gov/sport/viewer/?dataset=lis_neus&product=vsm0-200percent&mode=nrt" target="_blank" rel="noreferrer">
                Visit SPoRT Viewer
              </Link>
            </div>
          </div>
        }
        {!loading && !exists &&
          <Typography variant='body1' sx={{ fontStyle: 'italic' }}>
            SPoRT maps for {datePart.slice(0, 4)}-{datePart.slice(4, 6)}-{datePart.slice(6, 8)} are not available at this time.
          </Typography>
        }

      </>
    )
}